export default "__VITE_ASSET__mwap2rp8__"